import * as React from "react";
import NotificationInterface from "@app/Interface/NotificationInterface";
import { Button, DropdownItem, Split, SplitItem } from "@patternfly/react-core";
import ProducerInterface from "@app/Interface/ProducerInterface";
import ProducerModel from "@app/Model/ProducerModel";

interface NotificationGroupProps {
    fpuId: number;
    notifications: NotificationInterface[];
    producers: ProducerInterface[];
    onFpuChange: (fpu: ProducerInterface) => void;
}

const NotificationGroup: React.FC<NotificationGroupProps> = ({ fpuId, notifications, producers, onFpuChange }) => {

    const [fpuNotifications, setFpuNotifications] = React.useState<NotificationInterface[]>([]);

    const [producer, setProducer] = React.useState<ProducerInterface>(new ProducerModel());

    // get the producer information
    React.useEffect(() => {

        const foundProducer = producers.find(producer => producer.producerId === fpuId);

        if (foundProducer) {
            setProducer(foundProducer);
        }

    }, [fpuId, producers]);

    // get the first notification that matches the 
    React.useEffect(() => {

        const filteredNotifications = notifications.filter(notification => notification.fpu === fpuId && notification.dismissed === false);

        if (filteredNotifications) {
            setFpuNotifications(filteredNotifications);
        }

    }, [fpuId, notifications]);

    return (
        <DropdownItem key={`dropdown-group-${fpuId}`} component="div">
            <div>{producer.alphaName} - {fpuId}</div>
            <div>Notifications: {fpuNotifications.length}</div>
            <Button variant="link" className="pf-u-p-0" onClick={() => onFpuChange(producer)}>Jump to FPU</Button>
            {/* <Split hasGutter isWrappable>
                <SplitItem isFilled>
                    <div>{producer.alphaName} - {fpuId}</div>
                    <div>Notifications: {fpuNotifications.length}</div>
                    <Button variant="link" className="pf-u-p-0" onClick={() => onFpuChange(producer)}>Jump to FPU</Button>
                </SplitItem>
                <SplitItem isFilled className="pf-u-text-align-right">
                    Notifications: {fpuNotifications.length}
                </SplitItem>
            </Split> */}
        </DropdownItem>
    );

}

export default NotificationGroup;
